import { defineStore } from "pinia";
import Services from '@/services/sutting/placeAffiliationsServices'
import { mapList, mapPlaceAffiliation } from '@/helpers/mapFuncs'

export const usePlaceAffiliationsStore = defineStore("placeAffiliations", {
persist: true,
state:()=>({
    placeAffiliation: {},
    placeAffiliations: [],
}),
getters : {
    getPlaceAffiliation() {
        return mapPlaceAffiliation(this.placeAffiliation)
    },
    getPlaceAffiliations() {
        return this.placeAffiliations.map(mapPlaceAffiliation)
    },
    getPlaceAffiliationsList() {
        return this.placeAffiliations.map(mapList)
    }
},
actions : {
    /** Start Sets */
    setPlaceAffiliation(placeAffiliation) {
        this.placeAffiliation = placeAffiliation
    },
    setPlaceAffiliations(placeAffiliations) {
        this.placeAffiliations = placeAffiliations
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setPlaceAffiliation(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setPlaceAffiliations(response.data.data??[])
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.placeAffiliations.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.placeAffiliations[this.placeAffiliations.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.placeAffiliations = this.placeAffiliations.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
